import { AxiosResponse, AxiosError, AxiosRequestConfig, RawAxiosResponseHeaders, AxiosResponseHeaders } from "axios"
import store from "@/store"
import { axios } from "@/plugins/http-axios";

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

// Убираем 'data' из AxiosRequestConfig чтобы избежать конфликта с нашим 'body'

interface RequestOptions<D = any> extends Omit<AxiosRequestConfig, 'data' | 'method'> {
  method: HttpMethod
  body?: D
}

interface ApiResponse<T = any> extends Pick<AxiosResponse<T>, 'data' | 'status' | 'headers'> {
  data: T
  status: number
  headers: RawAxiosResponseHeaders | AxiosResponseHeaders 
}

interface ApiResponseError {
    errorMessage?: string
    message?: string
    [key: string]: any 
}

const request = async <T = any, D = any>(options: RequestOptions<D>): Promise<ApiResponse<T>> => {
    try {
        const methods = ['POST', 'PUT', 'PATCH']
        const response: AxiosResponse<T> = await axios({
            ...options,
            url: options.url,
            data: methods.includes(options.method) ? options.body : undefined,
            })
        return { data: response.data, status: response.status, headers: response.headers }
    } catch (error) {
        const axiosError = error as AxiosError
        const printedAxiosError = {
            ...axiosError,
            uri: options.url,
            message: axiosError.message
        }
        if (axiosError.response?.status === 409) {
            const errorData = axiosError.response.data as ApiResponseError
            store.dispatch('addSuccess', { 
                message: errorData.errorMessage || errorData.message || 'Ошибка', 
                color: 'error' 
            })
        } else {
            store.dispatch('setError', printedAxiosError);
        }
        return Promise.reject(printedAxiosError)
    }
}

const api = {
    get: <T = any>(options: Omit<RequestOptions, 'method'>) => request<T>({ ...options, method: 'GET' }),
    post: <T = any, D = any>(options: Omit<RequestOptions<D>, 'method'>) => request<T, D>({ ...options, method: 'POST' }),
    put: <T = any, D = any>(options: Omit<RequestOptions<D>, 'method'>) => request<T, D>({...options, method: 'PUT'}),
    patch: <T = any, D = any>(options: Omit<RequestOptions<D>, 'method'>) => request<T, D>({...options, method: 'PATCH'}),
    delete: <T = any>(options: Omit<RequestOptions, 'method'>) => request<T>({...options, method: 'DELETE'})
}

export { api }